const state = {
	Hello: 22,
	World: 33,
	actions: 33,
	loginUser: 4,
	searchType: null,
	cityAddress: null,
}
export default state
